module.exports = __webpack_public_path__ + "media/images/icons/hands-1fef07ddd29baf2bbacdb7fadcd48433.png";